export default __webpack_public_path__ + "static/media/misc-pantry3-480w.69c10a14.png";